"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function About() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3,
    rootMargin: "0px 0px -50px 0px"
  });
  return <section id="about" className="relative bg-background py-24 md:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {}
          <div ref={leftRef} className={`space-y-8 transition-all duration-[var(--duration-slow)] ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            {}
            <div className="space-y-2">
              <div className="text-[72px] md:text-[96px] font-bold text-accent leading-none tracking-tight">
                $2B+
              </div>
              <div className="text-muted-foreground text-lg uppercase tracking-widest">
                In Transactions
              </div>
            </div>

            {}
            <div className="w-20 h-[3px] bg-accent"></div>

            {}
            <div className="space-y-6">
              <h2 className="text-foreground">Strategic Real Estate Advisory</h2>
              <p className="text-muted-foreground text-lg leading-relaxed">
                DealForge focuses on creating opportunity before transactions
                occur. Our approach emphasizes development intelligence, deal
                structuring, and lifecycle real estate expertise—serving
                developers, landowners, investors, and sophisticated clients
                across residential and commercial markets.
              </p>
              <p className="text-muted-foreground text-lg leading-relaxed">With over 20 years of experience and more than $2 billion in completed transactions, we bring institutional-grade insight to every engagement!<br /></p>
            </div>

            {}
            <div className="grid grid-cols-2 gap-8 pt-4">
              <div>
                <div className="text-4xl font-bold text-primary mb-2">20+</div>
                <div className="text-sm text-muted-foreground uppercase tracking-wider">
                  Years Experience
                </div>
              </div>
              <div>
                <div className="text-4xl font-bold text-primary mb-2">500+</div>
                <div className="text-sm text-muted-foreground uppercase tracking-wider">
                  Deals Closed
                </div>
              </div>
            </div>
          </div>

          {}
          <div ref={rightRef} className={`relative transition-all duration-[var(--duration-slow)] delay-150 ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="relative aspect-[4/5] rounded-(length:--radius-md) overflow-hidden shadow-strong">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542976/img/modern_architecture_development.png" alt="Modern architectural development" className="w-full h-full object-cover hover-lift" />
              {}
              <div className="absolute inset-0 bg-linear-to-t from-primary-dark/40 via-transparent to-transparent"></div>
            </div>

            {}
            <div className="absolute -bottom-8 -left-8 w-32 h-32 bg-accent/10 rounded-full blur-3xl"></div>
            <div className="absolute -top-8 -right-8 w-40 h-40 bg-primary/5 rounded-full blur-3xl"></div>
          </div>
        </div>
      </div>
    </section>;
}